export const fetchMethods = {
  GET: 'GET',
  PUT: 'PUT',
  POST: 'POST',
  DELETE: 'DELETE',
  ALL: 'ALL',
} as const;

type TKeys = keyof typeof fetchMethods;
export type THttpMethod = (typeof fetchMethods)[TKeys];

export type THttpBodyType = string | URLSearchParams | FormData;
